<script>
import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import WithLoader from '@/components/WithLoader'

export default WithLoader(ControlButton, {
  events: ['click'],
  pendingProp: 'is-loading',
})
</script>
